import { NavigateButton } from '@eastcoal/common/components/Button/NavigateButton'
import { stringifyUrl } from '@eastcoal/common/utils/querystring'

import { ApplyStatus } from '@eastcoal/shared/enums/ApplyStatus'
import { BizType } from '@eastcoal/shared/enums/BizType'

import { PRICE_COMPARE_DETAIL_PAGE_PATH } from '../../../../../../pages/TradeSession/Detail/PriceCompare/constants/path'

import { HomePriceCompareDetailButtonProps } from './interface'

export const HomePriceCompareDetailButton = ({
  record: { bizId, bizType, applyStatus }
}: HomePriceCompareDetailButtonProps) => {
  if (
    applyStatus !== ApplyStatus.APPLY_SUCCESS ||
    bizType !== BizType.PRICE_COMPARE
  ) {
    return null
  }

  const to = () => {
    return stringifyUrl({
      url: PRICE_COMPARE_DETAIL_PAGE_PATH,
      query: { id: bizId }
    })
  }

  return (
    <NavigateButton newtab to={to} type='primary'>
      前往报价
    </NavigateButton>
  )
}
